import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Form, FormGroup, Button } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import FormItem from '../../../common/forms/FormItem';
import { isRequired, validateEndDate } from '../../../../utils/validators';
import RegisteredBusSelect from '../../../common/forms/select/RegisteredBusSelect';
import DatePicker from '../../../common/forms/input/DatePicker';

export class FuelConsumptionReportPerBusSearchForm extends Component {
  validateDate = (value, allValues) =>
    validateEndDate(value, allValues.fromDate);

  render() {
    return (
      <Form onSubmit={this.props.handleSubmit}>
        <FormGroup row>
          <FormItem label="Bus">
            <Field
              name="registeredBusId"
              component={RegisteredBusSelect}
              isMulti
            />
          </FormItem>
        </FormGroup>
        <FormGroup row>
          <FormItem label="Fecha" required>
            <Row>
              <Col>
                <Field
                  name="fromDate"
                  component={DatePicker}
                  placeholder="Fecha de Inicio"
                  validate={[isRequired]}
                />
              </Col>
              <Col>
                <Field
                  name="toDate"
                  component={DatePicker}
                  placeholder="Fecha de Fin"
                  validate={[isRequired, this.validateDate]}
                />
              </Col>
            </Row>
          </FormItem>
        </FormGroup>
        <Row>
          <Col className="flex row-reverse">
            <Button type="submit" color="secondary" outline>
              <i className="fa fa-search" /> Buscar
            </Button>
          </Col>
        </Row>
      </Form>
    );
  }
}

FuelConsumptionReportPerBusSearchForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'FuelConsumptionReportPerBusSearchForm',
})(FuelConsumptionReportPerBusSearchForm);
